var _filter, _polygon, _circle, _circle2, _line, _line2, _circle3, _circle4, _circle5, _circle6, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secondaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,8 44,16 44,32 32,40 20,32 20,16",
    fill: "url(#primaryGradient)",
    stroke: "#6366f1",
    strokeWidth: 2,
    filter: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 8,
    fill: "url(#secondaryGradient)",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 4,
    fill: "url(#accentGradient)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 32,
    stroke: "#06b6d4",
    strokeWidth: 1.5,
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 40,
    y2: 24,
    stroke: "#06b6d4",
    strokeWidth: 1.5,
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 2,
    fill: "#f59e0b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 2,
    fill: "#ef4444"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 2,
    fill: "#ec4899"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 28,
    r: 2,
    fill: "#06b6d4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 52,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#6366f1",
    textAnchor: "middle"
  }, "\n    NFTxtreme\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftIcon);
export default __webpack_public_path__ + "static/media/nft-icon.b62441c7c87652644c5ef63b1c38232e.svg";
export { ForwardRef as ReactComponent };